import {EduTradingPackage, EduTradingPackageContent} from "core/redux/eduTrading/EduTradingReduxState";
import {EduTreeCourse, EduTreeLesson, EduTreeSection} from "protocol/edutrading/GetEducationalContentTree";
import {TSMap} from "typescript-map";
import Platform from "platform/Platform";
import {EduTradingSetPackagesContent} from "core/redux/eduTrading/EduTradingReduxActions";
import Utils from "platform/util/Utils";

export class EduTradingState {

    private static _instance: EduTradingState;
    private AccountSwitchedPostActions: {[key: number]: () => void} = {};
    private _Packages: EduTradingPackage[];
    private _Courses: EduTreeCourse[];

    private constructor() {}

    public static instance(): EduTradingState {
        return this._instance || (this._instance = new this());
    }

    public setAccountSwitchedPostAction(accountId: number, action: () => void): void {
        this.AccountSwitchedPostActions[accountId] = action;
    }

    public runAccountSwitchedPostAction(accountId: number): void {
        const action: () => void = this.AccountSwitchedPostActions[accountId];
        if (action) {
            delete this.AccountSwitchedPostActions[accountId];
            action();
        }
    }

    public set Packages(value: EduTradingPackage[]) {
        this._Packages = value;
        this.resolvePackagesContent();
    }

    public set Courses(value: EduTreeCourse[]) {
        this._Courses = value;
        this.resolvePackagesContent();
    }

    private resolvePackagesContent(): void {
        if (Utils.isArrayNotEmpty(this._Packages) && Utils.isArrayNotEmpty(this._Courses)) {
            const PackagesContent: TSMap<number, EduTradingPackageContent> = new TSMap();
            const packageNamePerId: {[key: string]: number} = {};
            this._Packages.forEach((eduPackage: EduTradingPackage) => packageNamePerId[eduPackage.name] = eduPackage.id);
            const minCoursesPackage: {[key: number]: string} = {};
            const minBooksPackage: {[key: number]: string} = {};
            const minMarketAnalysisPackage: {[key: number]: string} = {};
            const minMarketScannersPackage: {[key: number]: string} = {};
            const minToolsPackage: {[key: number]: string} = {};

            const SwapPackageNameIfNeed = (lesson: EduTreeLesson, minResourcePackage: {[key: number]: string}): void => {
                const minPackage: string = minResourcePackage[lesson.LessonGuid];
                if (Utils.isEmpty(minPackage) || packageNamePerId[minPackage] > packageNamePerId[lesson.LeastRequiredPackageName]) {
                    minResourcePackage[lesson.LessonGuid] = lesson.LeastRequiredPackageName;
                }
            };
            this._Courses.forEach((course: EduTreeCourse) => {
                if (course.Id === 8) {
                    course.Sections?.forEach((section: EduTreeSection) => {
                        section.Lessons?.forEach((lesson: EduTreeLesson) => {
                            if (section.Id === 12) {
                                SwapPackageNameIfNeed(lesson, minBooksPackage);
                            } else if (section.Id === 14) {
                                SwapPackageNameIfNeed(lesson, minMarketAnalysisPackage);
                            } else if (section.Id === 15) {
                                SwapPackageNameIfNeed(lesson, minMarketScannersPackage);
                            } else if (section.Id === 16) {
                                SwapPackageNameIfNeed(lesson, minToolsPackage);
                            }
                        });
                    });
                } else {
                    course.Sections?.forEach((section: EduTreeSection) => {
                        section.Lessons?.forEach((lesson: EduTreeLesson) => {
                            const minPackage: string = minCoursesPackage[course.Id];
                            if (Utils.isEmpty(minPackage) || packageNamePerId[minPackage] > packageNamePerId[lesson.LeastRequiredPackageName]) {
                                minCoursesPackage[course.Id] = lesson.LeastRequiredPackageName;
                            }
                        });
                    });
                }
            });

            Object.keys(packageNamePerId).forEach((packageName: string) => {
                const packageId: number = packageNamePerId[packageName];
                const packageContent: EduTradingPackageContent = {courses: [], books: [], marketAnalysis: [], tools: [], marketScanners: []};
                Object.keys(minCoursesPackage).forEach((courseId: string) => {
                    const minCoursePackageName: string = minCoursesPackage[courseId];
                    if (packageNamePerId[minCoursePackageName] <= packageId) {
                        packageContent.courses.push(parseInt(courseId));
                    }
                });
                Object.keys(minBooksPackage).forEach((bookId: string) => {
                    const minBookPackageName: string = minBooksPackage[bookId];
                    if (packageNamePerId[minBookPackageName] <= packageId) {
                        packageContent.books.push(bookId);
                    }
                });
                Object.keys(minMarketAnalysisPackage).forEach((marketAnalysisId: string) => {
                    const minMarketAnalysisPackageName: string = minMarketAnalysisPackage[marketAnalysisId];
                    if (packageNamePerId[minMarketAnalysisPackageName] <= packageId) {
                        packageContent.marketAnalysis.push(marketAnalysisId);
                    }
                });
                Object.keys(minMarketScannersPackage).forEach((marketScannerId: string) => {
                    const minMarketScannerPackageName: string = minMarketScannersPackage[marketScannerId];
                    if (packageNamePerId[minMarketScannerPackageName] <= packageId) {
                        packageContent.marketScanners.push(marketScannerId);
                    }
                });
                Object.keys(minToolsPackage).forEach((toolId: string) => {
                    const minToolPackageName: string = minToolsPackage[toolId];
                    if (packageNamePerId[minToolPackageName] <= packageId) {
                        packageContent.tools.push(toolId);
                    }
                });
                PackagesContent.set(packageId, packageContent);
            });
            Platform.dispatch(EduTradingSetPackagesContent({
                PackagesContent
            }));
        }
    }
}
